<template>

  <b-modal
    ref="modal"
    :id="'modal-' + siteNumber"
    :title="'Site: ' + siteNumber"
    :no-close-on-backdrop="true"
    no-fade
    hideHeaderClose
    @shown="handleModalShown">

    <template v-slot:modal-header>

      <div class="w-100 d-flex justify-content-between">
        <h1 class="site-graph-modal-header flex-grow-1 d-flex justify-content-between m-0">
          <span class="h3 font-weight-light mt-auto mt-auto mb-auto">{{siteName_Formatted}}</span>
          <span class="fs-6 font-weight-light mt-auto mb-auto mr-3">
            USGS Streamflow Site #{{siteNumber}}
          </span>
        </h1>

        <b-button
          class="m-auto btn-icon btn-icon-big"
          @click="closeDetail">

          <v-icon class="align-middle">
            close
          </v-icon>

        </b-button>
      </div>

    </template>

    <div class="d-flex flex-column">

      <DetailGraphManager
        v-if="modalHasRendered"
        ref="detailGraphManager"
        :siteNumber="siteNumber"
        name="stationDetail"
        class="site-graph">
      </DetailGraphManager>

    </div>

    <template v-slot:modal-footer>
      <span></span>
    </template>

  </b-modal>

</template>

<script>

import constants      from '@/constants';

import DetailGraphManager from '@/components/detail/DetailGraphManager';

export default {
  props: ['siteNumber'],
  components: {
    DetailGraphManager
  },

  data() {
    return {
      modalHasRendered: false
    };
  },

  /**
   * Show the modal on component creation
   */
   created() {

    // Show the modal (could we move this to mount and get rid of nextTick?)
    this.$nextTick(() => this.$bvModal.show("modal-" + this.siteNumber));

    // When the modal is hidden (via close button or escape key) update the route to the mini detail
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      console.log('modal hidden running')
      this.$router.push({name: constants.RouteNames.MiniDetail, params: {
        // siteNumber: this.siteNumber
        siteNumber: this.$store.state.activeSite.reference.siteNumber
      }});

      // And... this is weird... remove the event handler on our way out
      //
      // Why here, and not on unmount? Because for some reason, this component gets created,
      // and mounted, over and over again, but never unmounted. Huh.
      //
      // So if we don't do this, we're adding a new event handler
      // - every time modal is shown
      // - but it never gets removed
      this.$root.$off('bv::modal::hidden')
    })
  },

  computed : {
    siteName_Formatted() {
      const siteName = this.$store.state.activeSite.reference.siteName;
      return siteName ? siteName.toLowerCase() : '';
    },
  },

  methods: {
    closeDetail() {
      this.$refs.modal.hide()
    },

    handleModalShown() {

      // After modal is created *and shown* is where we want to initialize the echarts instance, so that
      // it can size itselt properly https://apache.github.io/echarts-handbook/en/concepts/chart-size/
      this.modalHasRendered = true;
      if (!this.resizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.$refs.detailGraphManager) {
            this.$refs.detailGraphManager.resize();
          }
        });
        this.resizeObserver.observe(this.$refs.modal.$root.$el);
      }
    }
  },

};

</script>

<style lang="scss">

  // Bootstrap overrides

  .detail-modal {
    .modal-header {
      padding: 0rem 0rem !important;
    }
  }


  .modal-backdrop {
    opacity           : .8 !important;
    background-color: rgba(0, 0, 0, .5) !important;
  }

  .modal {
    // border: $foo;

    .site-graph {
      height  : 100%;
    }


    .site-graph-modal-header {
      text-transform: capitalize;
    }

    display: flex !important;

    .modal-dialog {
      margin:auto;
    }

    .modal-header {
      border-bottom     : none;
    }

    .modal-footer {
      position: absolute;

      /* bottom: 100px; */
      bottom: .5rem;
      right: 1rem;
      border: none;
    }
  }

  .modal-dialog.modal-md {
    min-width   : 90vw;
    max-width   : 90vw;

    .modal-header {
      border-bottom: $detail-modal-border;
      padding: 1rem;
      margin: 0;
    }

    .modal-content {
      min-height   : 90vh;
      max-height   : 90vh;

      border-radius: 15px;
      border: none;

      .modal-body {
        display     : flex;

        & > * {
          flex-grow : 1;
        }
      }
    }
  }

  // Hacked up mobile styles...
  @media (max-width: $breakpoint-desktop-min-width) {
    .modal-dialog.modal-md {

      .modal-content {
        min-height   : 80vh;
        max-height   : 80vh;
      }
    }

    .site-graph-modal-header {
      flex-direction: column;
      .h3 {
        font-size: 1.25rem;
        font-weight: 500 !important;
        margin-bottom: 0rem;
      }
      .h6 {
        font-size: 1rem;
      }


    }

    .modal-header button {
      position: relative;
      top: -10px;
      right: -8px;
    }
  }


</style>
